import { fr } from "./fr";
import { en } from "./en";

export const locales = {
  fr,
  en
};
